var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormalSchool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Formal_School",
    "data-name": "Formal School",
    transform: "translate(-455 -169)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4265",
    "data-name": "Rectangle 4265",
    width: 93,
    height: 93,
    rx: 10,
    transform: "translate(455 169)",
    fill: "#ffeffd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "graduation-hat",
    d: "M41.866,31.169V16.984l.745-.34a1.619,1.619,0,0,0,0-2.947L23.957,5.147a1.619,1.619,0,0,0-1.36,0L3.943,13.7a1.619,1.619,0,0,0,0,2.947l6.785,3.109L9.48,29.744a1.619,1.619,0,0,0,2.656,1.425q.259-.259.583-.534a4.323,4.323,0,0,1,3.368-1.619,8.971,8.971,0,0,1,6.137,2.105,1.619,1.619,0,0,0,2.105,0,8.7,8.7,0,0,1,5.117-2.105,5.214,5.214,0,0,1,4.518,1.716l.4.389A1.618,1.618,0,0,0,37.024,29.7l-1.231-9.959,2.834-1.263v12.7a4.712,4.712,0,0,0-3.239,4.469v4.987a1.619,1.619,0,0,0,1.619,1.619h6.477A1.619,1.619,0,0,0,45.1,40.626V35.638a4.712,4.712,0,0,0-3.239-4.469Zm-8.534-4.712a9,9,0,0,0-4.113-.615,11.626,11.626,0,0,0-5.975,2.073,11.9,11.9,0,0,0-7.384-2.073,9.019,9.019,0,0,0-2.688.551l.648-5.2L22.6,25.226a1.619,1.619,0,0,0,1.36,0l8.712-4.032ZM23.277,21.939,8.509,15.171,23.277,8.4l14.768,6.769ZM41.866,39.006H38.627V35.638a1.49,1.49,0,0,1,1.49-1.49h.259a1.49,1.49,0,0,1,1.49,1.49Z",
    transform: "translate(477.45 191.879)",
    fill: "#c523b9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormalSchool);
export default __webpack_public_path__ + "static/media/Formal-School.19d77237ea45ee1b2beab00fbd8db29d.svg";
export { ForwardRef as ReactComponent };